import React from 'react'
import { createRoot } from 'react-dom/client'
import { LocationMaps } from '../components/StaffPage/Map'

// <staff-location lang room building floor-image building-image>: the floor plan with the room
// marked and the site plan, on a person's page. Without a shadow root: the plans are styled by iti.css.
export class StaffLocationElement extends HTMLElement {
  connectedCallback () {
    const mountPoint = document.createElement('div')
    this.appendChild(mountPoint)
    createRoot(mountPoint).render(<LocationMaps
      lang={this.getAttribute('lang') === 'en' ? 'en' : 'de'}
      room={this.getAttribute('room') ?? undefined}
      building={this.getAttribute('building') ?? undefined}
      floorImage={this.getAttribute('floor-image') ?? undefined}
      buildingImage={this.getAttribute('building-image') ?? undefined}
    />)
  }
}
customElements.define('staff-location', StaffLocationElement)
